<div class="row-options" [ngClass]="{'create-options': isCreate}">
    <!-- cell-3-3-1 -->
    <div class="input-cell" (click)="selectLayout('layout-class-1')">
        <div *ngIf="isCreate" class="description">Elements(3) Rows(3) Columns(1)</div>
        <!-- <div class="graphic cell-3-1">
            <div></div>
            <div></div>
            <div></div>
        </div> -->
        <svg width="60" height="60" xmlns="http://www.w3.org/2000/svg">
            <!-- Rectangle 1: 20px height -->
            <rect _ngcontent-ng-c50094703="" x="0" y="0" width="60" height="18" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5"></rect>
            
            <!-- Rectangle 2: 30px height, with a 4px gap -->
            <rect _ngcontent-ng-c50094703="" x="0" y="22" width="60" height="22" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5"></rect>
            
            <!-- Rectangle 3: 10px height, with a 4px gap -->
            <rect _ngcontent-ng-c50094703="" x="0" y="48" width="60" height="10" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5"></rect>
        </svg>
        
        <!-- <svg width="60" height="60" xmlns="http://www.w3.org/2000/svg">
            <rect x="0" y="0" width="60" height="22" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" />
            <rect x="0" y="26" width="60" height="28" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" />
            <rect x="0" y="58" width="60" height="8" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" />
        </svg> -->
    </div>
    <!-- cell-4-4-1 -->
    <div class="input-cell" (click)="selectLayout('layout-class-2')">
        <div *ngIf="isCreate" class="description">Elements(4) Rows(4) Columns(1)</div>
        <!-- <div class="graphic cell-4-1">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div> -->
        <svg width="60" height="60" xmlns="http://www.w3.org/2000/svg">
            <rect x="0" y="0" width="60" height="16" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" />  <!-- 2fr -->
            <rect x="0" y="20" width="60" height="16" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" /> <!-- 2fr -->
            <rect x="0" y="40" width="60" height="8" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" />  <!-- 1fr -->
            <rect x="0" y="52" width="60" height="8" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" />  <!-- 1fr -->
        </svg>
        
    </div>
    <!-- cell-3-2-2 -->
    <div class="input-cell" (click)="selectLayout('layout-class-3')">
        <div *ngIf="isCreate" class="description">Elements(4) Rows(4) Columns(1)</div>
        <svg width="60" height="60" xmlns="http://www.w3.org/2000/svg">
            <!-- First Row -->
            <rect x="0" y="0" width="28" height="36" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" />  <!-- 1st Column -->
            <rect x="32" y="0" width="28" height="36" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" /> <!-- 2nd Column -->
        
            <!-- Second Row (Spanning both columns) -->
            <rect x="0" y="40" width="60" height="16" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" /> <!-- Spanned Element -->
        </svg>
        
    </div>
    <!-- cell-4-2-2-a -->
    <div class="input-cell" (click)="selectLayout('layout-class-3')">
        <div *ngIf="isCreate" class="description">Elements(4) Rows(2) Columns(2)</div>
        <!-- <div class="graphic cell-4-2">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div> -->
        <svg width="60" height="60" xmlns="http://www.w3.org/2000/svg">
            <!-- First Row -->
            <rect x="0" y="0" width="28" height="36" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" />  <!-- 1st Column -->
            <rect x="32" y="0" width="28" height="36" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" /> <!-- 2nd Column -->
        
            <!-- Second Row -->
            <rect x="0" y="40" width="28" height="16" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" />  <!-- 1st Column -->
            <rect x="32" y="40" width="28" height="16" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" /> <!-- 2nd Column -->
        </svg>
        
    </div>
    <!-- cell-3-1-3 -->
    <div class="input-cell" (click)="selectLayout('layout-class-4')">
        <div *ngIf="isCreate" class="description">Elements(3) Rows(1) Columns(3)</div>
        <!-- <div class="graphic cell-3-3">
            <div></div>
            <div></div>
            <div></div>
        </div> -->
        <svg width="60" height="60" xmlns="http://www.w3.org/2000/svg">
            <!-- First Column -->
            <rect x="0" y="0" width="16" height="58" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" />
            
            <!-- Second Column -->
            <rect x="20" y="0" width="16" height="58" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" />
        
            <!-- Third Column -->
            <rect x="40" y="0" width="16" height="58" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" />
        </svg>
        
    </div>
    <!-- cell-4-2-3 -->
    <div class="input-cell" (click)="selectLayout('layout-class-5')">
        <div *ngIf="isCreate" class="description">Elements(4) Rows(2) Columns(3)</div>
        <!--     <div class="graphic cell-4-3">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        </div> -->
        <svg width="60" height="60" xmlns="http://www.w3.org/2000/svg">
        <!-- First Row -->
        <rect x="0" y="0" width="16" height="36" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" />  <!-- 1st Column -->
        <rect x="20" y="0" width="16" height="36" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" /> <!-- 2nd Column -->
        <rect x="40" y="0" width="18" height="36" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" /> <!-- 3rd Column -->
    
        <!-- Second Row -->
        <rect x="0" y="40" width="58" height="16" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" />  <!-- 1st Column -->
    </svg>
    </div>
    <!-- cell-3-1-2 -->
    <div class="input-cell" (click)="selectLayout('layout-class-6')">
        <div *ngIf="isCreate" class="description">Elements(4) Rows(2) Columns(3)</div>
        <svg width="60" height="60" xmlns="http://www.w3.org/2000/svg">
            <!-- First Row: Spanning two columns -->
            <rect x="0" y="0" width="60" height="20" fill="none" 
                stroke="#fff" stroke-width="1.25" opacity="0.5"/>
        
            <!-- Second Row, First Column (with 4px gap from top row) -->
            <rect x="0" y="24" width="28" height="36" fill="none" 
                stroke="#fff" stroke-width="1.25" opacity="0.5"/>
        
            <!-- Second Row, Second Column (with 4px gap between columns) -->
            <rect x="32" y="24" width="28" height="36" fill="none" 
                stroke="#fff" stroke-width="1.25" opacity="0.5"/>
        </svg>
        
    </div>
    <!-- cell-3-1-2 -->   
    <div class="input-cell" (click)="selectLayout('layout-class-7')">
        <div *ngIf="isCreate" class="description">Elements(4) Rows(2) Columns(2)</div>
        <!-- <div class="graphic cell-4-4">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div> -->
        <svg width="60" height="60" xmlns="http://www.w3.org/2000/svg">
            <!-- First Row -->
            <rect x="0" y="0" width="28" height="28" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" />  <!-- 1st Column -->
            <rect x="32" y="0" width="28" height="28" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" /> <!-- 2nd Column -->
        
            <!-- Second Row -->
            <rect x="0" y="32" width="28" height="28" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" />  <!-- 1st Column -->
            <rect x="32" y="32" width="28" height="28" fill="none" stroke="#fff"  stroke-width="1.25" opacity="0.5" /> <!-- 2nd Column -->
        </svg>
        
    </div>
</div>